import { deserialize, identifier, serializable } from "serializr";
import { IJsonObject } from "../api";
import { Lead } from "../leads";

interface IProps {
	id?: number | null;
	name?: string | null;
	color?: string | null;
	lead?: Lead | null;
}

export class ProjectTaskLabel {
	public static fromJson(json: IJsonObject): ProjectTaskLabel {
		return deserialize(ProjectTaskLabel, json);
	}

	public static fromJsonArray(json: IJsonObject[]): ProjectTaskLabel[] {
		return json.map((task: IJsonObject) => this.fromJson(task));
	}

	@serializable(identifier())
	public id: number | null;

	@serializable
	public name: string | null;

	@serializable
	public color: string | null;

	constructor({ id = null, name = null, color = null }: IProps = {}) {
		this.id = id;
		this.name = name;
		this.color = color;
	}
}
